<template>
  <div class="lpnlpnouter">
    <RecepContextMenu
      @open-editor-from-context="openEditorFromContext"
      @delete-recep="sendDeleteToParent"
    />

    <VirtualArea
      v-if="recepientsLoaded"
      :list="list"
      :areaheight="641"
      :itemheight="24"
      vscrollarea="recepscrollarea"
    >
      <template v-slot:list="{ item }">
        <div
          class="recep bg-primary-light cursor-pointer"
          :class="item.id == activereceps[0] ? ' recepactive' : ''"
          @click="setActive(item.id)"
          @contextmenu="setActive(item.id)"
          @dblclick="$emit('open-editor', 'edit')"
          @mouseover.self="
            showInfo($event, item.addr, item.comment, item.comment2)
          "
          @mouseleave="hideInfo()"
        >
          <q-icon
            name="check_circle"
            v-if="item.contentclass !== undefined"
            :class="
              typeof item.contentclass != 'undefined'
                ? 'freshicon q-mr-sm q-mt-xs'
                : ''
            "
            color="green-13"
          />
          <span
            :class="
              typeof item.contentclass != 'undefined' ? 'freshaddress' : ''
            "
            >{{ item.name }}</span
          >
          <q-icon
            v-show="item.id == activereceps[0]"
            @click.self.stop="printFromRecep()"
            bg-color="red"
            name="print"
            class="printfromrecep transall"
            right
            color="grey-3"
          />
          <div class="cmlo">
            <span
              v-if="s.list.showLbl && item.comment2 != ''"
              :class="
                'cml ' + (item.comment != '' && s.list.showCom ? 'chalf ' : '')
              "
              >{{ item.comment2 }}</span
            >
            <span
              v-if="item.comment != '' && s.list.showCom"
              :class="
                'cml ' + (item.comment2 && s.list.showLbl != '' ? 'chalf ' : '')
              "
              >{{ item.comment }}</span
            >
          </div>
        </div>
      </template>
    </VirtualArea>
    <div
      class="addrtip"
      v-bind:style="tipposition"
      v-html="hoveredrecep"
      v-show="showtip"
    ></div>
  </div>
</template>

<script>
import VirtualArea from "src/service/components/common/VirtualArea.vue";
import Filter from "src/service/components/mixins/Filter.vue";
import RecepContextMenu from "src/service/components/common/RecepContextMenu.vue";
export default {
  components: {
    VirtualArea,
    RecepContextMenu
  },
  mixins: [Filter],
  data() {
    return {
      showtip: false,
      tipposition: {
        left: "320px",
        top: 0
      },
      hoveredrecep: ""
    };
  },

  computed: {
    recepientsLoaded() {
      return this.$store.getters.IS_RECEPIENTS_LOADED;
    },
    recepients() {
      return this.$store.getters.GET_RECEPIENTS;
    },
    activereceps() {
      return this.$store.getters.GET_ACTIVERECEPS;
    },
    searchtpl() {
      return this.$store.getters.GET_SEARCHTPL;
    },
    s() {
      return this.$store.getters.SETTINGS_OBJECT;
    }
  },

  methods: {
    setActive(id) {
      this.$store.commit("SET_ACTIVE_RECEP", [id]);
    },
    showInfo(event, addr, comment = "", comment2 = "") {
      event.stopPropagation();
      this.tipposition.top = event.clientY - event.offsetY - 50 + "px";
      this.hoveredrecep =
        '<span class="addr">' +
        addr +
        "</span>" +
        (comment != "" ? '<span class="com">' + comment : "") +
        "</span>" +
        (comment2 != "" ? '<span class="tiplbl">' + comment2 + "</span>" : "");
      this.showtip = true;
    },
    hideInfo() {
      this.tipposition.top = 0;
      this.hoveredrecep = "";
      this.showtip = false;
    },
    printFromRecep() {
      this.$eventBus.$emit("print-from-recep");
      this.$store.commit("PRINT_FROM_RECEP");
    },
    openEditorFromContext(mode) {
      this.$emit("open-editor", mode);
    },
    sendDeleteToParent() {
      this.$emit("delete-recep");
    }
  }
};
</script>
<style lang="sass">
.recep
  overflow: hidden
  padding: 2px 4px
  border-bottom: 1px solid rgba(255, 255, 255, 0.14)
  -webkit-transition: all 0.25s
  -moz-transition: all 0.25s
  -o-transition: all 0.25s
  transition: all 0.25s
.recep:hover
  background: rgba(0, 0, 0, 0.15)
.trdiv .recepactive
  background: #e64c65
.trecepsarea
  width: 100%
  height: 100%
.recep span
  width: 184px
  display: block
  overflow: hidden
  float: left
  text-overflow: ellipsis
.printfromrecep
  background: rgb(80, 89, 123)
  border-radius: 3px !important
  height: 100% !important
  width: 20px !important
  font-size: 18px !important
  margin-top: 1px !important
  padding: 1px 3px !important
  float: right !important
  color: rgb(216, 216, 216)
.printfromrecep:hover, .printfromrecep:active
  background: rgb(60, 67, 97)
.freshicon
  float: left
.recep span.freshaddress
  width: 164px

.addrtip
  width: 230px
  z-index: 10000
  background: rgba(202, 60, 83, 0.8)
  position: fixed
  border-radius: 4px
  padding: 10px
  clear: both
  float: none
.addrtip .addr
  display: block
  width: 100%
.addrtip .com
  display: block
  background: rgba(0, 0, 0, 0.7)
  float: left
  clear: both
  padding: 2px 7px
  border-radius: 4px
.addrtip .tiplbl
  margin-top: 10px
  display: block
  background: rgba(0, 0, 0, 0.7)
  float: left
  clear: both
  padding: 2px 7px
  border-radius: 4px
.cmlo
  overflow: hidden
  width: 184px
  float: left
.recep span.cml
  font-size: 12px
  max-width: 100%
  float: left
  width: auto
  padding-right: 5px
  color: #f7f7ae
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
  box-sizing: border-box
  display: block
.recep span.cml.chalf
  max-width: 50%
.cmlo>.cml:first-child:before
  display: block
  float: left
  content: ""
  width: 11px
  height: 7px
  margin: 5px 3px 0 0
  background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAHCAYAAADebrddAAAACXBIWXMAAAsSAAALEgHS3X78AAAALUlEQVR4nGP48z/1Pz683ciUAYYZCClG1kCUYpgGohX/+Z/6n/omE+1m5NAAAAzN6Ii+mb4QAAAAAElFTkSuQmCC')
</style>
